"use client";

import { CalendarIcon } from "lucide-react";

import { EXAM_TIMEFRAME_OPTIONS } from "@/lib/onboarding/constants";

import type { StepProps } from "../types";
import { SingleChoiceStep, useChooseAndAdvance } from "../ui";

export function ExamDateStep(props: StepProps) {
  const choose = useChooseAndAdvance(props);
  return (
    <SingleChoiceStep
      kicker="Your exam"
      title="When is your exam?"
      options={EXAM_TIMEFRAME_OPTIONS.map((o) => ({ ...o, icon: CalendarIcon }))}
      selected={props.state.answers.exam_timeframe || undefined}
      onPick={(exam_timeframe) => choose({ exam_timeframe })}
    />
  );
}
